import type { RecordingMode } from '@/shared/api/transcriptor';

import { TRANSCRIPTOR_LANGUAGE } from '@/entities/transcriptor';

export type { RecordingMode };

export enum RecordingMethod {
  Record = 'record',
  Microphone = 'microphone',
  Upload = 'upload',
}

export type MicrophoneDevice = {
  deviceId: string;
  label: string;
  groupId: string;
};

export type RecordingState = {
  isRecording: boolean;
  isPaused: boolean;
  recordingTime: number;
  audioBlob?: Blob;
  audioUrl?: string;
};

export type TranscriptorRecordingState = {
  recordingMethod: RecordingMethod;
  language: TRANSCRIPTOR_LANGUAGE;
  uploadedFile: File | null;
  isUploading: boolean;
  uploadError: string | null;
  isProcessing: boolean;
  processingError: string | null;
};

export type TreatmentProcessingMode = 'liveFill' | 'upload';

export type TranscriptorPreferences = {
  schemaId: string;
  templateSeriesIds: string[];
  recordingMethod: RecordingMethod;
  language: TRANSCRIPTOR_LANGUAGE;
  languageByOrganization?: Record<string, string>;
  treatmentModeByOrganization?: Record<string, TreatmentProcessingMode>;
};
